import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=fdc4ec2c&scoped=true&"
import script from "./ShowMore.vue?vue&type=script&lang=js&"
export * from "./ShowMore.vue?vue&type=script&lang=js&"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=fdc4ec2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc4ec2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc4ec2c')) {
      api.createRecord('fdc4ec2c', component.options)
    } else {
      api.reload('fdc4ec2c', component.options)
    }
    module.hot.accept("./ShowMore.vue?vue&type=template&id=fdc4ec2c&scoped=true&", function () {
      api.rerender('fdc4ec2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/ShowMore.vue"
export default component.exports